module.exports = __webpack_public_path__ + "static/media/profile-banner.a87abcf8.jpg";